import { MeetingVideoGridDesktop } from './MeetingVideoGridDesktop'
import { MeetingVideoGridMobile } from './MeetingVideoGridMobile'

export function MeetingVideoGrid() {
  return (
    <>
      <MeetingVideoGridDesktop />
      <MeetingVideoGridMobile />
    </>
  )
}
